import { Form, Input, Button, Typography, Card, Space } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import MainLayout from "@/components/PatientLayout/MainLayout";
import { post } from "@/libs/axios";
const { Title, Text } = Typography;
import { useNavigate } from "react-router-dom";

const PatientForgotPassword = () => {
  const themeColor = localStorage.getItem('themeColor')
  const navigate = useNavigate();

  const onFinish = async (values) => {
    const res = await post("sessions", values);
    console.log("Received values:", values);
    // Here you would handle the password reset request

    localStorage.setItem("Authorization", res.data.auth_token);
    localStorage.setItem("Email", res.data.email);
    navigate("/");
  };

  return (
    <MainLayout>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "50vh", // Assuming header height is 64px
          padding: "20px 0", // Add some padding to avoid content touching the edges
        }}
      >
        <Card
          style={{
            width: 450,
            // maxWidth: '90%', // Ensure card doesn't overflow on smaller screens
            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
            borderRadius: 8,
          }}
        >
          <div style={{ padding: "20px" }}>
            <Title level={2} style={{ textAlign: "center", marginBottom: 24 }}>
              Forgot Your Password?
            </Title>
            <Form name="forgot_password" onFinish={onFinish} layout="vertical">
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: "Please input your email!" },
                  { type: "email", message: "Please enter a valid email!" },
                ]}
              >
                <Input
                  prefix={<MailOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
                  placeholder="Enter Your Email Address"
                  size="large"
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  size="large"
                  style={{
                    background: themeColor,
                    border: "none",
                    boxShadow: `0 4px 6px ${themeColor}`,
                    height: "40px",
                  }}
                >
                  Send password reset instructions
                </Button>
              </Form.Item>
            </Form>

            <Space
              direction="vertical"
              size="middle"
              style={{ width: "100%", marginTop: 20 }}
            >
              <Text style={{ textAlign: "center", display: "block" }}>
                Remember your password?{" "}
                <Link to="/patient/signin" style={{ fontWeight: "bold" }}>
                  Sign in
                </Link>
              </Text>
              <Text style={{ textAlign: "center", display: "block" }}>
                Don't have an account?{" "}
                <Link to="/patient/signup" style={{ fontWeight: "bold" }}>
                  Sign up
                </Link>
              </Text>
            </Space>
          </div>
        </Card>
      </div>
    </MainLayout>
  );
};

export default PatientForgotPassword;
